<div class="modal-header">
  <div class="d-flex align-items-center gap-2">
    <div class="modal-title" i18n>Create Listing</div>
    <app-page-help articleId="bwLpAhAakEiCw8up5RXbjH" videoId="-"></app-page-help>
  </div>
  <button (click)="close()" type="button" class="close">
    <i class="far fa-times"></i>
  </button>
</div>

<app-loading-section *ngIf="creationApproved === null"></app-loading-section>

<!-- TV4-6504: the channel manager refuses property creation until support approves the account -->
<div class="container-box shadow-none text-center py-5" *ngIf="creationApproved === false">
  <div class="w-75 m-auto">
    <i class="fas fa-exclamation-triangle fa-2x text-warning"></i>
    <h6 class="mt-2" i18n>Listing Creation Not Enabled</h6>
    <p i18n>Booking.com listing creation is not enabled for this account. Contact support to enable it.</p>
    <div class="d-flex gap-3 align-items-center justify-content-center mt-4">
      <button class="btn btn-secondary-primary" (click)="close()">
        <i class="cs-icon cs-icon-check"></i> <ng-container i18n>Close</ng-container>
      </button>
    </div>
  </div>
</div>

<mat-stepper *ngIf="creationApproved" [linear]="true" #stepper class="m-3">
  <mat-step i18n-label label="Enter Entity ID" [state]="stepper.selectedIndex > 0 ? 'done' : 'number'">
    <app-bdc-create-property-entity-id
      (next)="legalEntityId = $event; stepper.next()"
    ></app-bdc-create-property-entity-id>
  </mat-step>
  <mat-step i18n-label label="Property Details" [state]="stepper.selectedIndex > 1 ? 'done' : 'number'">
    <app-bdc-create-property-details
      [legalEntityId]="legalEntityId"
      [form]="detailsForm"
      [isLoading]="isLoading"
      (prev)="stepper.previous()"
      (next)="stepper.next()"
      (rentalChange)="onRentalChange($event)"
    ></app-bdc-create-property-details>
  </mat-step>
  <mat-step i18n-label label="Property Address" [state]="stepper.selectedIndex > 2 ? 'done' : 'number'">
    <ng-template matStepContent>
      <app-bdc-create-property-address
        [form]="addressForm"
        [isLoading]="isLoading"
        (prev)="stepper.previous()"
        (next)="onSave()"
      ></app-bdc-create-property-address>
    </ng-template>
  </mat-step>
  <mat-step i18n-label label="Complete" [state]="stepper.selectedIndex > 3 ? 'done' : 'number'">
    <app-bdc-create-property-complete
      [propertyId]="createdPropertyId"
      [connectionError]="connectionFailure"
      (connect)="onConnectNow()"
      (prev)="stepper.previous()"
      (done)="close()"
    ></app-bdc-create-property-complete>
  </mat-step>
  <ng-template matStepperIcon="done">
    <i class="cs-icon cs-icon-check2 text-xs"></i>
  </ng-template>
  <ng-template matStepperIcon="edit">
    <i class="cs-icon cs-icon-check2 text-xs"></i>
  </ng-template>
</mat-stepper>
